import React from 'react';
import RouterProvider from './router/RouterProvider';

function App() {
  return <RouterProvider />;
}

export default App;
